import { render, staticRenderFns } from "./fx.vue?vue&type=template&id=4e0dcf0e&scoped=true&"
import script from "./fx.vue?vue&type=script&lang=js&"
export * from "./fx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0dcf0e",
  null
  
)

export default component.exports